/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'notifications';
const componentName = 'syslog-controller';
const prefix = `${moduleName}.${componentName}`;

export const modalHeaderEdit = `${prefix}.modalHeaderEdit`;
export const modalHeaderNew = `${prefix}.modalHeaderNew`;
export const syslogServerInputLabel = `${prefix}.syslogServerInputLabel`;
export const syslogServerInputPlaceholder = `${prefix}.syslogServerInputPlaceholder`;
export const portInputPlaceholder = `${prefix}.portInputPlaceholder`;
export const addSyslogServerButtonLabel = `${prefix}.addSyslogServerButtonLabel`;
export const actionBtnValidateSettings = `${prefix}.actionBtnValidateSettings`;
export const columnTitleSyslogServer = `${prefix}.columnTitleSyslogServer`;
export const emptySyslogServersLabel = `${prefix}.emptySyslogServersLabel`;
export const sysLogTitleLabel = `${prefix}.sysLogTitleLabel`;

export const ENGLISH = {
    [modalHeaderEdit]: 'Edit Syslog Notification: {0}',
    [modalHeaderNew]: 'New Syslog Notification: {0}',
    [syslogServerInputLabel]: 'Syslog Server',
    [syslogServerInputPlaceholder]: 'IP Address or Hostname',
    [portInputPlaceholder]: 'Default port 514',
    [addSyslogServerButtonLabel]: '+ Add Syslog Server',
    [actionBtnValidateSettings]: 'Validate Settings',
    [columnTitleSyslogServer]: 'Syslog Server',
    [emptySyslogServersLabel]: 'No Syslog Servers',
    [sysLogTitleLabel]: 'Validate Syslog Settings',
};
